import type { CoreApiClient } from "../client";
import { createUserMutations } from "../mutations/user.mutations";
import { createUserQueries } from "../queries/user.queries";

export const createUserRepository = (api: CoreApiClient) => ({
  ...createUserQueries(api),
  ...createUserMutations(api),
});
